import { Style, registerObjectClassFormatter, registerObjectFormatter } from './core.ts';
import { DateTime, dateTimeDebug } from './time/formatting.ts';

export * from './time/formatting.ts';
export * from './time/holidays.ts';
export * from './time/parsing.ts';
export * from './time/periods.ts';
export * from './time/standard.ts';
export * from './time/utils.ts';
export * from './time/weekdays.ts';

registerObjectFormatter(Date, (v, b) => {
  b.override(Style.dateTime, dateTimeDebug(DateTime.fromJSDate(v)));
  return { result: 'builder' } as const;
});
registerObjectClassFormatter<DateTime>(DateTime, (v, b) => {
  b.override(Style.dateTime, dateTimeDebug(v));
  return { result: 'builder' } as const;
});
